module.exports = __webpack_public_path__ + "images/emoji/wink.68fd92b1d5b1ae903b0f.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/wink.png
// module id = k6HH
// module chunks = 24